import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Clickable column header for server-side sorting: shows the direction when
 * this column is the active sort, a neutral up/down glyph otherwise. The
 * parent owns the state and refetches with the new sortBy/sortDir.
 */
export function SortHeader<F extends string>({
  label,
  field,
  currentSort,
  currentDir,
  onSort,
  className,
}: {
  label: string;
  field: F;
  currentSort: F | undefined;
  currentDir: 'asc' | 'desc';
  onSort: (field: F) => void;
  className?: string;
}) {
  const isActive = currentSort === field;
  return (
    <button
      type="button"
      onClick={() => onSort(field)}
      aria-sort={isActive ? (currentDir === 'asc' ? 'ascending' : 'descending') : 'none'}
      className={cn('inline-flex items-center gap-1 uppercase hover:text-foreground', className)}
    >
      {label}
      {isActive ? (
        currentDir === 'asc' ? (
          <ArrowUp className="h-3 w-3" />
        ) : (
          <ArrowDown className="h-3 w-3" />
        )
      ) : (
        <ArrowUpDown className="h-3 w-3 opacity-50" />
      )}
    </button>
  );
}
